export const photo = 'data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAFKADAAQAAAABAAAAFAAAAACRFdLHAAAEp0lEQVQ4EXWUy28bVRTGv5m587LHTpzYjuPaTVvaIlraTCQqkIrUrJCQWGTFikX5CyBig1SkhhUSEhCExKILEgGiwCZBqAtggUtbCakKmahN2ygkcZw4blLbsR079rw54ypSeI08tmd07+9+5zsPDv9zvfP6K2P3Hjwa3mqaox3X08Hx4DjOEDiWU2RmGEv5H/5rK/fPlz//ekMv5f+cmv7kU71QrhOHgygwOJ4PIoLneTC6BUEw+sLSmzlj2TjM4A8//HTzxsRWYW3+848m9c1KHYoiBarARIFAAYyDQDskkUdI4nVVlubffeO1q4cZwsHDj7/MTPiue3X+1m/YWFkB6YEWUuB6HhhRiEsQETLBZCZAERlc30OsJzL66sUX6rm5xd8DVjfkGxSmb5vzpfwaZr6Ygui7SCTiSKaS2CyW0G536AAf2cEUJIHDVmkHhZ0qLNdFhtacOXUckhoauTI5bbCA6tnWdBDa/bt3wTkWTh/P4sLFC4gfHYLZNuFYJhipEjkfZrWM1QdLaDQaeNx0sV2u4sSxLJjiTxFqRPhu5psxMv4tPgDeuQ1GwLMnMsgcG4KqRSApMrRwGDL5KYoiOM+F22oQHFinpJmk8pmhLEIRLfXSyLkF9nDe0NWwSptUyGS4TcdokRAULUzJIJ8cB/ApYNrouU7XW0bgfloTlhmazQ6tEyEqCpgNnV3/8qvRVF8Uqf4YFAqrtzeCeCYDUQ1RIigZVCIBkOMp01Q6giRDIsWe66NfVfF4j4CyAl6gimD2KNvvtPXiEwccbTqZTSNzNA2HE1Bc34QaCkPTVFIgwe7so7pdxnphA41KBTIpjlJUPHbhURQeVYMgsGFmeaCsUmIo4YlkHFp/P/nkYGlhERubJYw8dxKn9GGs3nuAP4xFFJsm0r0a9GezsEj98foeJFmGQGHDsjlG9WSITLgU1Joc1tA/kIJKZoqRGIXSwF7HgUuKm3v7SA4OIk2b+2I9SA8NwltZw3nHRyyZhO245C9nMNf1cm3fvtTY70BLJKFEogj3hPHiy3GcO/88zFaTuoMhEY8hwUQcOXO2247WXo3eC0gPj8Cl1oRLHw85nkrGCLoiKFKJFAohjerSgUxGR/viUKg7FFLfS1nlTBMhTaPeFtCu7cJkCgQSYFoWaru72FovGPzGVmWWpC7YlDWQxWQm6qUSZdYlqARqDArH6h7ICT4VeQd2u4VyaRscCWjtt7G5XsDN23cWrl2fnSUCwCT5cjBFZNLtlzewvbaK1bk52LRZjPZgt1JFrdZAT/oILMp27ckOao19yqYEsgzVeh3bT8qXA1YXmM8XDQr9/SiVSDRzFNUKhUOqHt661VUrmBZUj0eVlBSXl1Arl2nkSHQr4Mi/gcH0+OJysTvGur0ckO8/yk/wVhuOaV7lKZOxI2nMTH2L05kBZBIJcsCHRfWl0LSp1lrgklmywiML3PEPPr42GTCCqzttnv59+v39h2/r4b7ktGe2h1u2Rwq3kSaoawdDooMSTZo6F4aayi7QwZfHx6/8bcD+C3gAn/nsvTEenh4aGBzlRVWnVsBOIW8szhm5JiRj8uvZ2YO1h3//ArWa8OZmtQ4fAAAAAElFTkSuQmCCiVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAFKADAAQAAAABAAAAFAAAAACRFdLHAAAEp0lEQVQ4EXWUy28bVRTGv5m587LHTpzYjuPaTVvaIlraTCQqkIrUrJCQWGTFikX5CyBig1SkhhUSEhCExKILEgGiwCZBqAtggUtbCakKmahN2ygkcZw4blLbsR079rw54ypSeI08tmd07+9+5zsPDv9zvfP6K2P3Hjwa3mqaox3X08Hx4DjOEDiWU2RmGEv5H/5rK/fPlz//ekMv5f+cmv7kU71QrhOHgygwOJ4PIoLneTC6BUEw+sLSmzlj2TjM4A8//HTzxsRWYW3+848m9c1KHYoiBarARIFAAYyDQDskkUdI4nVVlubffeO1q4cZwsHDj7/MTPiue3X+1m/YWFkB6YEWUuB6HhhRiEsQETLBZCZAERlc30OsJzL66sUX6rm5xd8DVjfkGxSmb5vzpfwaZr6Ygui7SCTiSKaS2CyW0G536AAf2cEUJIHDVmkHhZ0qLNdFhtacOXUckhoauTI5bbCA6tnWdBDa/bt3wTkWTh/P4sLFC4gfHYLZNuFYJhipEjkfZrWM1QdLaDQaeNx0sV2u4sSxLJjiTxFqRPhu5psxMv4tPgDeuQ1GwLMnMsgcG4KqRSApMrRwGDL5KYoiOM+F22oQHFinpJmk8pmhLEIRLfXSyLkF9nDe0NWwSptUyGS4TcdokRAULUzJIJ8cB/ApYNrouU7XW0bgfloTlhmazQ6tEyEqCpgNnV3/8qvRVF8Uqf4YFAqrtzeCeCYDUQ1RIigZVCIBkOMp01Q6giRDIsWe66NfVfF4j4CyAl6gimD2KNvvtPXiEwccbTqZTSNzNA2HE1Bc34QaCkPTVFIgwe7so7pdxnphA41KBTIpjlJUPHbhURQeVYMgsGFmeaCsUmIo4YlkHFp/P/nkYGlhERubJYw8dxKn9GGs3nuAP4xFFJsm0r0a9GezsEj98foeJFmGQGHDsjlG9WSITLgU1Joc1tA/kIJKZoqRGIXSwF7HgUuKm3v7SA4OIk2b+2I9SA8NwltZw3nHRyyZhO245C9nMNf1cm3fvtTY70BLJKFEogj3hPHiy3GcO/88zFaTuoMhEY8hwUQcOXO2247WXo3eC0gPj8Cl1oRLHw85nkrGCLoiKFKJFAohjerSgUxGR/viUKg7FFLfS1nlTBMhTaPeFtCu7cJkCgQSYFoWaru72FovGPzGVmWWpC7YlDWQxWQm6qUSZdYlqARqDArH6h7ICT4VeQd2u4VyaRscCWjtt7G5XsDN23cWrl2fnSUCwCT5cjBFZNLtlzewvbaK1bk52LRZjPZgt1JFrdZAT/oILMp27ckOao19yqYEsgzVeh3bT8qXA1YXmM8XDQr9/SiVSDRzFNUKhUOqHt661VUrmBZUj0eVlBSXl1Arl2nkSHQr4Mi/gcH0+OJysTvGur0ckO8/yk/wVhuOaV7lKZOxI2nMTH2L05kBZBIJcsCHRfWl0LSp1lrgklmywiML3PEPPr42GTCCqzttnv59+v39h2/r4b7ktGe2h1u2Rwq3kSaoawdDooMSTZo6F4aayi7QwZfHx6/8bcD+C3gAn/nsvTEenh4aGBzlRVWnVsBOIW8szhm5JiRj8uvZ2YO1h3//ArWa8OZmtQ4fAAAAAElFTkSuQmCC';

function randomInteger(min = 1, max = 100000) {
  // получить случайное число от (min-0.5) до (max+0.5)
  const rand = min - 0.5 + Math.random() * (max - min + 1);
  return Math.round(rand);
}

export const resourcesMock = [
  {
    id: randomInteger(),
    title: 'Place 2',
    place_id: 1,
    children: [
      {
        id: randomInteger(),
        title: 'Shift 1',
        shift_id: 1,
        children: [
          {
            title: 'Job 3',
            id: randomInteger(),
            job_type_id: 5,
            children: [
              {
                title: 'Yurii Topchii',
                photo: ' ',
                id: randomInteger(),
                employee_id: 1,
              },
              {
                title: 'test grouwnu',
                photo: ' ',
                id: randomInteger(),
                employee_id: 1,
              },
            ],
          },
          {
            title: 'Job 3',
            id: randomInteger(),
            job_type_id: 5,
            lastJobType: true,
            children: [
              {
                title: 'Yurii Topchii',
                photo: ' ',
                id: randomInteger(),
                employee_id: 1,
                lastJobType: true,
              },
              {
                title: 'test grouwnu',
                photo: ' ',
                id: randomInteger(),
                employee_id: 1,
                lastJobType: true,
              },
            ],
          },
        ],
      },
      {
        id: randomInteger(),
        title: 'Shift 2',
        shift_id: 1,
        lastShift: true,
        children: [
          {
            title: 'Job 4',
            id: randomInteger(),
            job_type_id: 7,
            lastShift: true,
            children: [
              {
                title: 'Yurii Topchii 2',
                photo: ' ',
                id: randomInteger(),
                employee_id: 1,
                lastShift: true,
              },
              {
                title: 'test grouwnu 2',
                photo: ' ',
                id: randomInteger(),
                employee_id: 1,
                lastShift: true,
              },
            ],
          },
        ],
      },
      {
        id: randomInteger(),
        title: 'Shift 3',
        shift_id: 1,
        lastShift: true,
        // children: [
        //   {
        //     title: 'Job 51',
        //     id: '41-4',
        //     job_type_id: 7,
        //     lastShift: true,
        //     children: [
        //       {
        //         title: 'Yurii Topchii 2',
        //         photo: ' ',
        //         id: '31-1-1',
        //         employee_id: 1,
        //         lastShift: true,
        //       },
        //       {
        //         title: 'test grouwnu 2',
        //         photo: ' ',
        //         id: '13-1-2',
        //         employee_id: 1,
        //         lastShift: true,
        //       },
        //     ],
        //   },
        // ],
      },
    ],
  },
  {
    id: randomInteger(),
    title: 'Place 2',
    place_id: 1,
    children: [
      {
        id: randomInteger(),
        title: 'Shift 1',
        shift_id: 1,
        children: [
          {
            title: 'Job 3',
            id: randomInteger(),
            job_type_id: 5,
            lastJobType: true,
            children: [
              {
                title: 'Yurii Topchii',
                photo: ' ',
                id: randomInteger(),
                employee_id: 1,
                lastJobType: true,
              },
              {
                title: 'test grouwnu',
                photo: ' ',
                id: randomInteger(),
                employee_id: 1,
                lastJobType: true,
              },
            ],
          },
        ],
      },
      {
        id: randomInteger(),
        title: 'Shift 2',
        shift_id: 1,
        children: [
          {
            title: 'Job 4',
            id: randomInteger(),
            job_type_id: 7,
            lastShift: true,
            children: [
              {
                title: 'Yurii Topchii 2',
                photo: ' ',
                id: randomInteger(),
                employee_id: 1,
                lastShift: true,
              },
              {
                title: 'test grouwnu 2',
                photo: ' ',
                id: randomInteger(),
                employee_id: 1,
                lastShift: true,
              },
            ],
          },
        ],
      },
    ],
  },
];
